module.exports = __webpack_public_path__ + "assets/d57c5277b5dd20c5b35f2a2bd66a6e70.png";